import { ALLOW_WS_OVERRIDE, ES_WS_QS_KEY, ES_WS_SS_KEY, ES_WS_URL } from '@skynet/config-provider';

import { createWsConnect } from '@skynet/data-ws-core';

import { prefix } from './actions';

/**
 * Resolves the ES WebSocket URL from query-string, sessionStorage, or the
 * default env value, then dispatches a `connect` action for the ES channel.
 *
 * @example
 * store.dispatch(wsEsConnect());
 */
export const wsEsConnect = createWsConnect(prefix, {
  defaultUrl: ES_WS_URL,
  ssKey: ES_WS_SS_KEY,
  qsKey: ES_WS_QS_KEY,
  allowOverride: ALLOW_WS_OVERRIDE,
});
